export default {
    baseUrl:'https://api.yahala.fun',
    apiUrl:'https://api.yahala.fun/api',
};